import { render, staticRenderFns } from "./ForumChatThreadCardHeaderMainAside.vue?vue&type=template&id=c094242c&scoped=true"
import script from "./ForumChatThreadCardHeaderMainAside.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardHeaderMainAside.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardHeaderMainAside.vue?vue&type=style&index=0&id=c094242c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c094242c",
  null
  
)

export default component.exports